export default "__VITE_ASSET__CZVZ3QxG__"